import React from "react";
import AuthGuardContainer from "../containers/AuthGuardContainer";
import DashboardContainer from "../containers/DashboardContainer";

function DashboardScreen({ toggleDrawer }) {
  return (
    <AuthGuardContainer>
        <DashboardContainer toggleDrawer={toggleDrawer} />
    </AuthGuardContainer>
  );
}

export default DashboardScreen;